import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AthleteResultsRoutingModule } from "./athlete-results-routing.module";
import { BoostrapAthleteResultsComponent } from "./components/boostrap-athlete-results/boostrap-athlete-results.component";
import { ResultsAthleteFiltersService } from "./services/results-athlete-filters.service";
import { ServicesModule, ComponentsModule } from "world-archery-lib";
import { CommonPageComponentsModule } from "src/app/common-page-components/common-page-components.module";
import { AthleteIndividualResultsComponent } from "./components/athlete-individual-results/athlete-individual-results.component";
import { AthleteTeamResultsComponent } from "./components/athlete-team-results/athlete-team-results.component";

@NgModule({
  declarations: [
    BoostrapAthleteResultsComponent,
    AthleteIndividualResultsComponent,
    AthleteTeamResultsComponent
  ],
  imports: [
    CommonModule,
    CommonPageComponentsModule,
    ComponentsModule,
    AthleteResultsRoutingModule
  ],
  providers: []
})
export class AthleteResultsModule {}
